export default {"src":"/_next/static/media/mail_done.6b9a2240.svg","height":189,"width":194};